import {api} from "../../store/actions";
import {Encryption} from "ubs-framework/v2/common/function";
import {getCookie} from "ubs-framework/v2/common/function";
import * as htmlToImage from 'html-to-image';

export const searchInArray = (str, array, key) => {
    const escapeRegExp = (str) => {
        return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    };

    str = escapeRegExp(str).replace(/\*/g, '').replace(/\|/g, '');
    const pattern = new RegExp(str.toLowerCase());

    return array.filter((data) => {
        if (key) return !!data[key].toString().toLowerCase().match(pattern);
        else return !!JSON.stringify(data).toLowerCase().match(pattern);
    });
};

export const uploadHRMSFile = ({
                                   event = '',
                                   file = [],
                                   data = {},
                                   socketId = '',
                                   orgId = '',
                                   onUploadProgress = () => {
                                   },
                                   route = '/hrmsFileUpload',
                                   encrypt = true,
                                   bodyData = {}
                               }) => {
    return new Promise((resolve, reject) => {
        const payload = {}
        const fileFormData = []
        if (!event) resolve({error: true, message: 'Event is required'})
        for (let i = 0; i < file.length; i++) {
            let e = file[i]
            const rId = e?.rId || Math.random().toString(36).substr(2, 9).toString();
            if (e?.rId) e = e.obj
            payload[rId] = {
                size: e?.size,
                fileName: e?.name,
                mimeType: e?.type,
                lastModified: e?.lastModified,
            };
            fileFormData.push({key: rId, file: e});

        }
        const body = {
            event,
            "data": {
                ...(file.length && {payload}),
                ...data
            },
            orgId,
            socketId,
            ...((typeof bodyData === 'object' && bodyData !== null) && bodyData)
        }
        console.log(route, ' body', body, fileFormData)
        const formData = new FormData();
        formData.append('body', encrypt ? Encryption(body) : body);
        if (fileFormData?.length) {
            fileFormData.forEach(e => {
                formData.append(e.key, e.file);
            });
        }
        formData.append('finish', true);
        const config = {
            headers: {'Authorization': `Bearer ${getCookie('ubs_token')}`},
            onUploadProgress: e => {
                onUploadProgress(parseInt(e.loaded / e.total * 100));
            },
        };
        api.post(route, formData, config).then(res => {
            console.log(`Files uploaded: `, res?.data)
            resolve(res)
        }).catch((err) => {
            console.log(`Error in file upload: (${event}) ` + err?.message)
            resolve({error: true, message: 'Failed to upload file', data: err.response.data})
        })
    })
}

export const htmlToDataURL = (content) => {
    return new Promise((resolve, reject) => {
        let iframe = document.createElement('iframe');
        document.body.appendChild(iframe);
        let iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
        iframeDoc.body.innerHTML = content;
        htmlToImage.toPng(iframeDoc.body, {width: 1000, height: 900})
            .then(function (dataUrl) {
                resolve(dataUrl)
            })
            .catch(function (error) {
                resolve('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH0AAACmCAIAAAB4GxeeAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAFkSURBVHhe7dAxAQAADMOg+TfdyeAJErhF6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ejd6N3o3ehd2B5QkEUFx84t2QAAAABJRU5ErkJggg==')
                console.error('oops, something went wrong in html to image!', error);
            });
    })
}
